// React import intentionally omitted (no JSX in this file)

export interface MapEmbedProps {
  lat: number;
  lng: number;
  zoom?: number;
  label?: string;
  title?: string;
  className?: string;
}

/**
 * Simple map embed using OpenStreetMap; no API key required.
 * Generates a small bbox around the coordinate to show context.
 */
export function MapEmbed({ lat, lng, zoom = 15, label, title, className }: MapEmbedProps) {
  const delta = 0.01;
  const left = lng - delta;
  const right = lng + delta;
  const top = lat + delta;
  const bottom = lat - delta;
  const src = `https://www.openstreetmap.org/export/embed.html?bbox=${left}%2C${bottom}%2C${right}%2C${top}&layer=mapnik&marker=${lat}%2C${lng}#map=${zoom}/${lat}/${lng}`;
  const link = `https://www.openstreetmap.org/?mlat=${lat}&mlon=${lng}#map=${zoom}/${lat}/${lng}`;

  return (
    <div className={className}>
      <div className="relative w-full overflow-hidden rounded-lg border border-neutral-200 shadow-sm bg-neutral-50 aspect-video">
        <iframe
          title={title ?? label ?? "Map"}
          src={src}
          className="absolute inset-0 h-full w-full"
          loading="lazy"
          referrerPolicy="no-referrer-when-downgrade"
        />
      </div>
      <div className="mt-2">
        <a href={link} target="_blank" rel="noopener noreferrer" className="text-sm text-primary hover:underline">
          Open in OSM
        </a>
      </div>
    </div>
  );
}
